import React from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import {
  capitalizeWords,
  finderExamenByName,
} from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import { examenState } from "./state/atoms";
import AtencionIcon from "src/shared/icons/AtencionIcon";
import ModalidadIcon from "src/shared/icons/ModalidadIcon";
import EspecialidadIcon from "src/shared/icons/EspecialidadIcon";

const AutocompleteExamen = ({ size = "small", styles }) => {
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);

  const examenes = useRecoilValue(examenState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-examen"
        text="Examen"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-examen"
        options={examenes.map((option) => `${option.prS_DESCRIP}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.examenSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findSpeciality = finderExamenByName(examenes, value);
            console.log("EXAMEN SELECTED => ", examenes);
            setFilterSearchSelected({
              ...filterSearchSelected,
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: value,
                code: findSpeciality?.exA_CORREL,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Examen" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <EspecialidadIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteExamen;
